
import { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import api from '../../../api/Api';
import "./EmployeeDetails.css"
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function EmployeeDetails() {
  const { identy } = useParams();
  const [e, setEmployee] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();



  useEffect(() => {
    api.get(`/api/employees/${identy}`)
      .then((res) => setEmployee(res.data.response))
      .catch(() => setError("Failed to fetch Employee.")
      );


  }, [identy]);

  const handleEdit = () => navigate(`/employees/edit/${identy}`);

  const handleDelete = () => {
    const confirmDelete = window.confirm("Are you sure you want to delete this employee?");
    if (!confirmDelete) return;

    api.delete(`/api/employees/${identy}`)
      .then(() => navigate("/employees"))
      .catch((err) => {
      const msg = err.response?.data?.message || "Failed to delete employee.";
      toast.error(msg);
    });
  };

  if (!e) return <p className="text-center mt-5">Loading Employee...</p>;

  return (
    <div className="container-fluid p-3">
      {/* <ToastContainer position="bottom-right" autoClose={3000} /> */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <Link to="/employees" className="btn btn-secondary">← Back</Link>
        <div> <h4 className="fw-bold text-capitalize">{e.name}</h4></div>
        <div className="d-flex gap-2">
          <button className="btn btn-secondary" onClick={handleEdit}>Edit</button>
          <button className="btn btn-danger" onClick={handleDelete}>Delete</button>
        </div>
      </div>

      <div className="card p-3 border-0" style={{
        // ,overflowY:'auto'
      }} >
        {/* <div className="card-header bg-white border-0">
           
          </div> */}


        <div className="row g-2  d-flex justify-content-around">

          <div className="box bgcolor col-md-5  p-3">
            {Object.entries(e)
              .filter(([key]) => key !== 'identy' && key !== 'assignedAsset' && key !== 'createdBy' && key !== 'createdDate' && key !== 'modifiedBy' && key !== 'modifiedDate')
              .map(([key, value]) => (
                <div key={key} className="mb-2">
                  <strong className="text-capitalize">{key.replace(/([A-Z])/g, ' $1')}:</strong>{" "}
                  {value === null || value === undefined || value === "" ? "N/A" : String(value)}
                </div>
              ))}
          </div>


          <div className="box col-md-5 p-3" >


            <div className='row'>
              {e.assignedAsset && e.assignedAsset.length > 0 && (
              <div className="col mb-2">
                <h5 className="fw-bold">Assigned Assets</h5>
                {e.assignedAsset.map((asset, index) => (
                  <p key={index}>
                    {asset.assetName} <span>({asset.assetId})</span>
                  </p>
                ))}
              </div>
            )}





            <div className='col'>
              <h5 className="fw-bold">Audit Info</h5>
              <div style={{ marginLeft: '10px', lineHeight: '1.8' }}>
              <div><strong>Created By:</strong> {e.createdBy}</div>
              <div><strong>Modified By:</strong> {e.modifiedBy}</div>
              <div><strong>Created Date:</strong> {e.createdDate}</div>
              <div><strong>Modified Date:</strong> {e.modifiedDate}</div>
              </div>
            </div>
            </div>


          </div>
        </div>
      </div>

    </div>
  );
}

export default EmployeeDetails;
